var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIl2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 478,
    viewBox: "0 0 492 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3881 163.371H36.6981C40.3852 163.372 44.0363 162.647 47.4429 161.237C50.8496 159.827 53.945 157.76 56.5525 155.154C59.1599 152.548 61.2283 149.453 62.6395 146.048C64.0507 142.643 64.777 138.993 64.777 135.307V41.6711C64.7779 38.088 65.485 34.5402 66.858 31.2305C68.2309 27.9207 70.2428 24.9138 72.7787 22.3817C75.3145 19.8496 78.3246 17.8419 81.637 16.4733C84.9493 15.1047 88.499 14.402 92.0831 14.4055H120.3",
    stroke: "#5C1FDE",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.81891 163.175H74.7785",
    stroke: "#131833",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.22 163.044H139.53C143.217 163.043 146.868 163.768 150.275 165.178C153.681 166.588 156.777 168.655 159.384 171.261C161.992 173.868 164.06 176.962 165.471 180.367C166.882 183.772 167.609 187.422 167.609 191.108V422.251C167.609 429.484 170.483 436.421 175.599 441.535C180.715 446.65 187.653 449.523 194.889 449.523H223.105",
    stroke: "#5C1FDE",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.96 177.449C109.737 177.449 116.042 171.146 116.042 163.371C116.042 155.596 109.737 149.293 101.96 149.293C94.1829 149.293 87.8781 155.596 87.8781 163.371C87.8781 171.146 94.1829 177.449 101.96 177.449Z",
    fill: "#131833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.487 163.175H180.885",
    stroke: "#131833",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.051 163.044H242.361C246.048 163.043 249.7 163.768 253.106 165.178C256.513 166.588 259.608 168.655 262.216 171.261C264.823 173.868 266.892 176.962 268.303 180.367C269.714 183.772 270.44 187.422 270.44 191.108V284.744C270.44 291.977 273.314 298.914 278.43 304.028C283.546 309.143 290.485 312.016 297.72 312.016H325.937",
    stroke: "#1AF5BC",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.067 177.449C215.844 177.449 222.149 171.146 222.149 163.371C222.149 155.596 215.844 149.293 208.067 149.293C200.289 149.293 193.985 155.596 193.985 163.371C193.985 171.146 200.289 177.449 208.067 177.449Z",
    fill: "#131833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.852 326.742C358.629 326.742 364.934 320.439 364.934 312.664C364.934 304.889 358.629 298.586 350.852 298.586C343.075 298.586 336.77 304.889 336.77 312.664C336.77 320.439 343.075 326.742 350.852 326.742Z",
    fill: "#1CF8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.844 28.1562C153.621 28.1562 159.926 21.8532 159.926 14.0781C159.926 6.30297 153.621 0 145.844 0C138.066 0 131.762 6.30297 131.762 14.0781C131.762 21.8532 138.066 28.1562 145.844 28.1562Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64 463.595C258.418 463.595 264.722 457.292 264.722 449.516C264.722 441.741 258.418 435.438 250.64 435.438C242.863 435.438 236.558 441.741 236.558 449.516C236.558 457.292 242.863 463.595 250.64 463.595Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.508 341.148C479.244 341.148 492 328.395 492 312.664C492 296.933 479.244 284.181 463.508 284.181C447.773 284.181 435.017 296.933 435.017 312.664C435.017 328.395 447.773 341.148 463.508 341.148Z",
    fill: "#1CF8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.191 478C384.927 478 397.683 465.247 397.683 449.516C397.683 433.785 384.927 421.033 369.191 421.033C353.456 421.033 340.7 433.785 340.7 449.516C340.7 465.247 353.456 478 369.191 478Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.593 163.175H330.875",
    stroke: "#131833",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.531 205.605C410.863 205.605 429.777 186.697 429.777 163.371C429.777 140.046 410.863 121.137 387.531 121.137C364.199 121.137 345.285 140.046 345.285 163.371C345.285 186.697 364.199 205.605 387.531 205.605Z",
    fill: "#131833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.473 163.044C409.473 165.967 408.897 168.862 407.777 171.564C406.658 174.265 405.018 176.719 402.95 178.786C400.882 180.853 398.427 182.493 395.725 183.612C393.024 184.731 390.128 185.307 387.203 185.307V140.781C393.11 140.781 398.774 143.126 402.95 147.302C407.126 151.477 409.473 157.139 409.473 163.044Z",
    fill: "#1CF8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.203 140.781V185.307C381.297 185.307 375.633 182.961 371.457 178.786C367.28 174.611 364.934 168.948 364.934 163.044C364.934 157.139 367.28 151.477 371.457 147.302C375.633 143.126 381.297 140.781 387.203 140.781Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.051 312.01H424.21",
    stroke: "#1AF5BC",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.167 449.516H321.051",
    stroke: "#5C1FDE",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 498,
    height: 478,
    fill: "white",
    transform: "translate(-6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl2);
export default __webpack_public_path__ + "static/media/il2.99ca86ec929c27516fcd0671842924c5.svg";
export { ForwardRef as ReactComponent };